/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Box } from "@material-ui/core";

import {
  GET_CAMAROO_USERS,
  GET_CAMAROO_USERS_NEXT,
  GET_CAMAROO_USERS_PREV,
} from "graphql/query/admin";
import Table from "Components/Table/Table";
import { formStyles } from "./TableStyles";

const UsersList = ({
  setErrorMsg,
  searchQuery,
  actionPerformed,
  setActionPerformed,
  filter,
  userFilter,
}) => {
  const navigate = useNavigate();
  const classes = formStyles();
  const [users, setUsers] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [page, setPage] = useState(0);

  const { data, refetch, error, loading } = useQuery(GET_CAMAROO_USERS, {
    variables: {
      first: 10,
      orderBy: "createdAt_DESC",
      filters:
        searchQuery?.length === 0
          ? !filter
            ? {}
            : userFilter
          : { search: searchQuery },
    },
    fetchPolicy: "network-only",
  });

  const [getNextPage, { loading: nextPageLoader }] = useLazyQuery(
    GET_CAMAROO_USERS_NEXT
  );
  const [getPrevPage, { loading: prevPageLoader }] = useLazyQuery(
    GET_CAMAROO_USERS_PREV
  );

  const handleNextPage = async () => {
    if (pageInfo.hasNextPage) {
      const nextPageData = await getNextPage({
        variables: {
          first: 10,
          after: pageInfo.endCursor,
          orderBy: "createdAt_DESC",
          filters:
            searchQuery?.length === 0
              ? !filter
                ? {}
                : userFilter
              : { search: searchQuery },
        },
        fetchPolicy: "network-only",
      });

      if (nextPageData.data.users) {
        const list = nextPageData.data.users.edges.map((u) => ({ ...u.node }));
        setUsers(list);
        setPage(page + 1);
        setPageInfo(nextPageData.data.users.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const handlePreviousPage = async () => {
    if (pageInfo.hasPreviousPage) {
      const prevPageData = await getPrevPage({
        variables: {
          last: 10,
          before: pageInfo.startCursor,
          orderBy: "createdAt_DESC",
          filters:
            searchQuery?.length === 0
              ? !filter
                ? {}
                : userFilter
              : { search: searchQuery },
        },
        fetchPolicy: "network-only",
      });
      if (prevPageData.data.users) {
        const list = prevPageData.data.users.edges.map((u) => ({ ...u.node }));
        setUsers(list);
        setPage(page - 1);
        setPageInfo(prevPageData.data.users.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const setAllUsers = () => {
    if (data && data.users) {
      const list = data.users.edges.map((u) => ({ ...u.node }));
      setPageInfo(data.users.pageInfo);
      setUsers(list);
      setErrorMsg("");
    }
    setPage(0);
  };

  useEffect(() => {
    if (actionPerformed) {
      refetch();
      setActionPerformed(false);
    }
    if (error) {
      setErrorMsg("Error in loading data !");
    }
    setAllUsers();
  }, [data, actionPerformed, error, searchQuery, userFilter]);

  const handleViewButton = (id) => {
    const user = users.find((u) => u.id === id);
    navigate("/admin/user/view-user", { state: { id, user } });
  };

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    { id: "fullName", flag: "fullName", label: "Full Name", alignRight: false },
    { id: "email", flag: "email", label: "Email", alignRight: false },
    { id: "mobile", flag: "mobile", label: "Mobile", alignRight: false },
    { id: "category", flag: "category", label: "Category", alignRight: false },
    { id: "isBlocked", flag: "isBlocked", label: "Blocked", alignRight: false },
    { id: "createdAt", flag: "createdAt", label: "Created At", alignRight: false },
    {
      id: "actions",
      flag: { read: true },
      callback: { handleViewButton },
      label: "Actions",
      alignRight: false,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      <Table
        error={error}
        USERLIST={users}
        page={page}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        TABLE_HEAD={TABLE_HEAD}
        pageInfo={pageInfo}
        loading={loading || nextPageLoader || prevPageLoader}
      />
    </Box>
  );
};

export default UsersList;
